import { CDN_URL } from "@/constants/cdn";
import { transformComplementary } from "@/datastore/dataProvider";
import { fetchProducts } from "@/utils";

export async function getProductHandlesFromSkuIds(skuIds: string[]) {
  const response = await fetch(
    `https://culture-circle.azurewebsites.net/graphql`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        variables: {
          skuIds,
        },
        query: `query GetProductHandlesFromSkuIds($skuIds: [String!]!) {
          productHandles: allProducts(filters: {title: {inList: $skuIds}}, first: ${skuIds.length}) {
            edges {
              node {
                slug
              }
            }
          }
        }`,
      }),
    },
  );

  const data = await response.json();

  return (data?.data?.productHandles?.edges ?? [])
    ?.map((edge: any) => edge?.node?.slug)
    .filter(Boolean);
}

export async function getLowTicketSizeRecommendationFromHandles(
  handles: string[],
): Promise<Record<string, Record<string, string[]>>> {
  const responses = await Promise.allSettled(
    handles.map((handle) => getLowTicketSizeRecommendations(handle)),
  );

  const finalResponses: Record<string, Record<string, string[]>>[] = responses
    .map((response) => {
      if (response.status === "fulfilled") {
        return response.value;
      }

      return null;
    })
    .filter(Boolean);

  const mergedResponses = finalResponses.reduce((acc, curr) => {
    const keys = Object.keys(curr);

    keys.forEach((key) => {
      if (!acc[key]) {
        acc[key] = curr[key];
      } else {
        Object.keys(curr[key]).forEach((subkey) => {
          acc[key][subkey] = [
            ...(acc[key][subkey] ?? []),
            ...curr[key][subkey],
          ];
        });
      }
    });

    return acc;
  }, {});

  return mergedResponses;
}

export async function getLowTicketSizeRecommendations(id: string) {
  const path = `/${window.helium.brandData.orgId}/products/${id}/complementary-low-ticket-size${
    window.helium.brandData.storeId ? `.${window.helium.brandData.storeId}` : ""
  }.json`;

  const baseUrl = CDN_URL;

  const response = await fetch(baseUrl + path);

  const data = await response.json();

  return transform(transformComplementary(data));
}

interface ResponseItem {
  subcategory: string;
  attribute: string;
  attributeValue: string;
  results: string[];
}

async function transform(complementaryIds: string[]) {
  console.log({ complementaryIds });
  return Object.fromEntries(
    await Promise.all(
      Object.entries(complementaryIds).map(
        async ([category, subcategories]) => {
          if (Array.isArray(complementaryIds[category])) {
            const products = await fetchProducts(
              complementaryIds[category].slice(0, 5),
            );
            if (products.length === 0) return [category, {}];
            return [
              category,
              {
                complementary: products,
              },
            ];
          }

          const resolvedSubcategories = Object.fromEntries(
            await Promise.all(
              Object.entries(subcategories).map(async ([subcategory, ids]) => {
                return [subcategory, await fetchProducts(ids)];
              }),
            ),
          );

          return [category, resolvedSubcategories];
        },
      ),
    ),
  );
}

export const Products = [
  {
    id: "nike-court-vision-x-black-clover",
    title: "Nike Court Vision x Black Clover",
    description:
      "gender: MALE\n  otherInfo: \n  Shoes\n  Custom Shoes \n  \n  ",
    handle: "nike-court-vision-x-black-clover",
    vendor: "Knickgasm",
    "featuredImage.url":
      "https://cdn.shopify.com/s/files/1/0754/4094/7522/files/Nike-Court-Vision-x-Black-Clover-Knickgasm-5239.jpg?v=1734417812",
    "featuredImage.width": 1000,
    "featuredImage.height": 1000,
    "compareAtPriceRange.minVariantPrice.currencyCode": "INR",
    "compareAtPriceRange.minVariantPrice.amount": 8802,
    "compareAtPriceRange.maxVariantPrice.currencyCode": "INR",
    "compareAtPriceRange.maxVariantPrice.amount": 8802,
    updatedAt: "2025-01-30T07:33:25.769Z",
    sector: "apparel",
    category: "footwear",
    subcategory: "sneakers",
    "tags.persona.age_group": ["teens", "young adults", "adults"],
    "tags.persona.price_range": "mid-range",
    "tags.persona.key_preferences": ["fashion", "sports", "tech"],
    "tags.persona.key_values": ["individuality", "quality", "comfort"],
    "tags.persona.gender": ["male", "female"],
    "tags.usage.season": ["spring", "summer", "autumn"],
    "tags.usage.activities": [
      "walking",
      "running",
      "gym",
      "fitness",
      "basketball",
      "soccer",
      "volleyball",
      "dance",
      "socializing",
      "travel",
    ],
    "tags.usage.occasions": [
      "everyday",
      "casual",
      "sports",
      "gym",
      "travel",
      "shopping",
      "errands",
      "date night",
      "birthday",
      "concert",
    ],
    "tags.usage.weather": ["sunny", "cloudy", "mild"],
    "tags.visual.pattern": ["floral"],
    "tags.visual.isMulticolor": true,
    "tags.visual.color.primary.value": "white",
    "tags.visual.color.primary.shade": "bright",
    "featuredImage.altText": "Nike Court Vision x Black Clover",
    skus: [],
    image:
      "https://cdn.shopify.com/s/files/1/0754/4094/7522/files/Nike-Court-Vision-x-Black-Clover-Knickgasm-5239.jpg?v=1734417812",
    images: [
      {
        url: "https://cdn.shopify.com/s/files/1/0754/4094/7522/files/Nike-Court-Vision-x-Black-Clover-Knickgasm-5239.jpg?v=1734417812",
        width: 1000,
        height: 1000,
        altText: "Nike Court Vision x Black Clover",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0754/4094/7522/files/Nike-Court-Vision-x-Black-Clover-Knickgasm-5239.jpg?v=1734417812",
        width: 1000,
        height: 1000,
        altText: "Nike Court Vision x Black Clover",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0754/4094/7522/files/Nike-Court-Vision-x-Black-Clover-Knickgasm-5131.jpg?v=1734417810",
        width: 1000,
        height: 1000,
        altText: "Nike Court Vision x Black Clover",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0754/4094/7522/files/Nike-Court-Vision-x-Black-Clover-Knickgasm-2084.jpg?v=1734417809",
        width: 1000,
        height: 1000,
        altText: "Nike Court Vision x Black Clover",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0754/4094/7522/files/Nike-Court-Vision-x-Black-Clover-Knickgasm-8046.jpg?v=1734417807",
        width: 1000,
        height: 1000,
        altText: "Nike Court Vision x Black Clover",
      },
    ],
    variants: [
      {
        id: "UK2.5",
        title: "UK2.5",
        selectedOptions: [{ name: "Size", value: "UK2.5" }],
        price: { amount: 8802, currencyCode: "INR" },
        availableForSale: true,
        sku: "19234UK2.5",
      },
      {
        id: "UK 12",
        title: "UK 12",
        selectedOptions: [{ name: "Size", value: "UK 12" }],
        price: { amount: 9780, currencyCode: "INR" },
        availableForSale: true,
        sku: "19234UK 12",
      },
      {
        id: "UK 11",
        title: "UK 11",
        selectedOptions: [{ name: "Size", value: "UK 11" }],
        price: { amount: 9780, currencyCode: "INR" },
        availableForSale: true,
        sku: "19234UK 11",
      },
      {
        id: "UK 10",
        title: "UK 10",
        selectedOptions: [{ name: "Size", value: "UK 10" }],
        price: { amount: 9780, currencyCode: "INR" },
        availableForSale: true,
        sku: "19234UK 10",
      },
      {
        id: "UK 9",
        title: "UK 9",
        selectedOptions: [{ name: "Size", value: "UK 9" }],
        price: { amount: 9780, currencyCode: "INR" },
        availableForSale: true,
        sku: "19234UK 9",
      },
      {
        id: "UK 8",
        title: "UK 8",
        selectedOptions: [{ name: "Size", value: "UK 8" }],
        price: { amount: 9780, currencyCode: "INR" },
        availableForSale: true,
        sku: "19234UK 8",
      },
      {
        id: "UK 7",
        title: "UK 7",
        selectedOptions: [{ name: "Size", value: "UK 7" }],
        price: { amount: 9780, currencyCode: "INR" },
        availableForSale: true,
        sku: "19234UK 7",
      },
      {
        id: "UK 6",
        title: "UK 6",
        selectedOptions: [{ name: "Size", value: "UK 6" }],
        price: { amount: 9780, currencyCode: "INR" },
        availableForSale: true,
        sku: "19234UK 6",
      },
      {
        id: "UK 5",
        title: "UK 5",
        selectedOptions: [{ name: "Size", value: "UK 5" }],
        price: { amount: 9780, currencyCode: "INR" },
        availableForSale: true,
        sku: "19234UK 5",
      },
      {
        id: "UK 4",
        title: "UK 4",
        selectedOptions: [{ name: "Size", value: "UK 4" }],
        price: { amount: 9780, currencyCode: "INR" },
        availableForSale: true,
        sku: "19234UK 4",
      },
    ],
    options: [
      {
        name: "Size",
        values: [
          "UK2.5",
          "UK 12",
          "UK 11",
          "UK 10",
          "UK 9",
          "UK 8",
          "UK 7",
          "UK 6",
          "UK 5",
          "UK 4",
        ],
      },
    ],
    "priceRange.minVariantPrice.currencyCode": "INR",
    "priceRange.minVariantPrice.amount": 8802,
    "priceRange.maxVariantPrice.currencyCode": "INR",
    "priceRange.maxVariantPrice.amount": 8802,
    "tags.functional.arch_support": "moderate",
    "tags.functional.impact_protection": "moderate",
    "tags.functional.shock_absorption": "high",
    "tags.functional.slip_resistance": "high",
    "tags.functional.temperature_regulation": "medium",
    "tags.functional.energy_return": "medium",
    "tags.functional.flexibility_level": "high",
    "tags.functional.terrain_adaptability": ["road", "indoor", "outdoor"],
    "tags.functional.weight_distribution": "medium",
    "tags.functional.breathable_material": true,
    "tags.functional.moisture_wicking": false,
    "tags.functional.quick_dry": false,
    "tags.functional.stretch_fabric": false,
    "tags.functional.wrinkle_resistant": false,
    "tags.functional.ankle_support": true,
    "tags.visual.closure_type": ["lace-up"],
    "tags.visual.embellishment_type": ["print"],
    "tags.visual.silhouette": ["fit-and-flare"],
    "tags.visual.design_elements": ["graphic", "color block"],
    "tags.visual.texture_detail": ["smooth", "mesh"],
    "tags.visual.lace_style": ["flat"],
    "tags.visual.sole_design": ["cushioned", "slip-resistant"],
    "tags.visual.toe_shape": ["round"],
    "tags.visual.ankle_support": "low",
    "tags.visual.contrast_stitching": "black",
    "tags.visual.material": ["leather", "faux leather", "nylon"],
    "tags.visual.primary_material": "leather",
    "tags.visual.breathable_mesh": false,
    "tags.visual.reflective_detailing": false,
    "tags.visual.translucent_panels": false,
    "tags.visual.color.secondary.value": "green",
    "tags.visual.color.secondary.shade": "medium",
    "tags.visual.color.tertiary.value": "black",
    "tags.visual.color.tertiary.shade": "medium",
  },
  {
    id: "nike-air-force-1-x-dragon-waves",
    title: "Nike Air Force 1 x Dragon Waves",
    description:
      "gender: MALE\n  otherInfo: \n  Shoes\n  Custom Shoes \n  \n  ",
    handle: "nike-air-force-1-x-dragon-waves",
    vendor: "Knickgasm",
    "featuredImage.url":
      "https://cdn.shopify.com/s/files/1/0754/4094/7522/files/Nike-Air-Force-1-x-Dragon-Waves-Knickgasm-7394.jpg?v=1734417557",
    "featuredImage.width": 1000,
    "featuredImage.height": 1000,
    "compareAtPriceRange.minVariantPrice.currencyCode": "INR",
    "compareAtPriceRange.minVariantPrice.amount": 11772,
    "compareAtPriceRange.maxVariantPrice.currencyCode": "INR",
    "compareAtPriceRange.maxVariantPrice.amount": 11772,
    updatedAt: "2025-01-30T07:33:25.822Z",
    sector: "apparel",
    category: "footwear",
    subcategory: "sneakers",
    "tags.persona.age_group": ["teens", "young adults", "adults"],
    "tags.persona.price_range": "mid-range",
    "tags.persona.key_preferences": ["fashion", "sports", "tech"],
    "tags.persona.key_values": ["individuality", "quality", "comfort"],
    "tags.persona.gender": ["male"],
    "tags.usage.season": ["spring", "summer", "autumn"],
    "tags.usage.activities": [
      "walking",
      "running",
      "gym",
      "fitness",
      "dance",
      "socializing",
      "travel",
    ],
    "tags.usage.occasions": [
      "everyday",
      "casual",
      "party",
      "sports",
      "shopping",
      "errands",
    ],
    "tags.usage.weather": ["sunny", "cloudy", "mild"],
    "tags.visual.pattern": ["geometric", "abstract"],
    "tags.visual.isMulticolor": true,
    "tags.visual.color.primary.value": "white",
    "tags.visual.color.primary.shade": "bright",
    "featuredImage.altText": "Nike Air Force 1 x Dragon Waves",
    skus: [],
    image:
      "https://cdn.shopify.com/s/files/1/0754/4094/7522/files/Nike-Air-Force-1-x-Dragon-Waves-Knickgasm-7394.jpg?v=1734417557",
    images: [
      {
        url: "https://cdn.shopify.com/s/files/1/0754/4094/7522/files/Nike-Air-Force-1-x-Dragon-Waves-Knickgasm-7394.jpg?v=1734417557",
        width: 1000,
        height: 1000,
        altText: "Nike Air Force 1 x Dragon Waves",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0754/4094/7522/files/Nike-Air-Force-1-x-Dragon-Waves-Knickgasm-7394.jpg?v=1734417557",
        width: 1000,
        height: 1000,
        altText: "Nike Air Force 1 x Dragon Waves",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0754/4094/7522/files/Nike-Air-Force-1-x-Dragon-Waves-Knickgasm-6174.jpg?v=1734417556",
        width: 1000,
        height: 1000,
        altText: "Nike Air Force 1 x Dragon Waves",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0754/4094/7522/files/Nike-Air-Force-1-x-Dragon-Waves-Knickgasm-1698.jpg?v=1734417554",
        width: 1000,
        height: 1000,
        altText: "Nike Air Force 1 x Dragon Waves",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0754/4094/7522/files/Nike-Air-Force-1-x-Dragon-Waves-Knickgasm-51.jpg?v=1734417553",
        width: 1000,
        height: 1000,
        altText: "Nike Air Force 1 x Dragon Waves",
      },
    ],
    variants: [
      {
        id: "UK2.5",
        title: "UK2.5",
        selectedOptions: [{ name: "Size", value: "UK2.5" }],
        price: { amount: 11772, currencyCode: "INR" },
        availableForSale: true,
        sku: "19263UK2.5",
      },
      {
        id: "UK 12",
        title: "UK 12",
        selectedOptions: [{ name: "Size", value: "UK 12" }],
        price: { amount: 13080, currencyCode: "INR" },
        availableForSale: true,
        sku: "19263UK 12",
      },
      {
        id: "UK 11",
        title: "UK 11",
        selectedOptions: [{ name: "Size", value: "UK 11" }],
        price: { amount: 13080, currencyCode: "INR" },
        availableForSale: true,
        sku: "19263UK 11",
      },
      {
        id: "UK 10",
        title: "UK 10",
        selectedOptions: [{ name: "Size", value: "UK 10" }],
        price: { amount: 13080, currencyCode: "INR" },
        availableForSale: true,
        sku: "19263UK 10",
      },
      {
        id: "UK 9",
        title: "UK 9",
        selectedOptions: [{ name: "Size", value: "UK 9" }],
        price: { amount: 13080, currencyCode: "INR" },
        availableForSale: true,
        sku: "19263UK 9",
      },
      {
        id: "UK 8",
        title: "UK 8",
        selectedOptions: [{ name: "Size", value: "UK 8" }],
        price: { amount: 13080, currencyCode: "INR" },
        availableForSale: true,
        sku: "19263UK 8",
      },
      {
        id: "UK 7",
        title: "UK 7",
        selectedOptions: [{ name: "Size", value: "UK 7" }],
        price: { amount: 13080, currencyCode: "INR" },
        availableForSale: true,
        sku: "19263UK 7",
      },
      {
        id: "UK 6",
        title: "UK 6",
        selectedOptions: [{ name: "Size", value: "UK 6" }],
        price: { amount: 13080, currencyCode: "INR" },
        availableForSale: true,
        sku: "19263UK 6",
      },
      {
        id: "UK 5",
        title: "UK 5",
        selectedOptions: [{ name: "Size", value: "UK 5" }],
        price: { amount: 13080, currencyCode: "INR" },
        availableForSale: true,
        sku: "19263UK 5",
      },
      {
        id: "UK 4",
        title: "UK 4",
        selectedOptions: [{ name: "Size", value: "UK 4" }],
        price: { amount: 13080, currencyCode: "INR" },
        availableForSale: true,
        sku: "19263UK 4",
      },
      {
        id: "UK 3",
        title: "UK 3",
        selectedOptions: [{ name: "Size", value: "UK 3" }],
        price: { amount: 13080, currencyCode: "INR" },
        availableForSale: true,
        sku: "19263UK 3",
      },
    ],
    options: [
      {
        name: "Size",
        values: [
          "UK2.5",
          "UK 12",
          "UK 11",
          "UK 10",
          "UK 9",
          "UK 8",
          "UK 7",
          "UK 6",
          "UK 5",
          "UK 4",
          "UK 3",
        ],
      },
    ],
    "priceRange.minVariantPrice.currencyCode": "INR",
    "priceRange.minVariantPrice.amount": 11772,
    "priceRange.maxVariantPrice.currencyCode": "INR",
    "priceRange.maxVariantPrice.amount": 11772,
    "tags.functional.arch_support": true,
    "tags.functional.impact_protection": "moderate",
    "tags.functional.shock_absorption": "medium",
    "tags.functional.slip_resistance": "high",
    "tags.functional.temperature_regulation": "medium",
    "tags.functional.energy_return": "high",
    "tags.functional.flexibility_level": "medium",
    "tags.functional.terrain_adaptability": ["road", "indoor", "outdoor"],
    "tags.functional.weight_distribution": "medium",
    "tags.functional.breathable_material": true,
    "tags.functional.moisture_wicking": false,
    "tags.functional.quick_dry": false,
    "tags.functional.stretch_fabric": false,
    "tags.functional.wrinkle_resistant": false,
    "tags.functional.ankle_support": false,
    "tags.visual.embellishment_type": ["prints"],
    "tags.visual.silhouette": ["straight"],
    "tags.visual.design_elements": ["print", "panels"],
    "tags.visual.texture_detail": ["smooth", "leather"],
    "tags.visual.lace_style": ["round"],
    "tags.visual.sole_design": ["flat"],
    "tags.visual.toe_shape": ["round"],
    "tags.visual.ankle_support": "none",
    "tags.visual.contrast_stitching": "white",
    "tags.visual.material": ["leather", "cotton"],
    "tags.visual.primary_material": "leather",
    "tags.visual.breathable_mesh": false,
    "tags.visual.reflective_detailing": false,
    "tags.visual.translucent_panels": false,
    "tags.visual.color.secondary.value": "red",
    "tags.visual.color.secondary.shade": "bright",
    "tags.visual.length_variation": ["regular"],
  },
];
